<template>
  <div class="mobile-artwork-detail-box">
    <div class="top-img-box relative">
      <img class="art-img" :src="artworkInfo.artworkLogoPath" alt />
    </div>
    <div class="name-box common-flex-box">
      <strong class="name ellipsis">《{{ artworkInfo.chArtworkName }}》</strong>
      <span class="common-tags mobile-tag" v-if="artworkInfo.excellent">{{
        $t("LastTranslate.ScreenTitle1")
      }}</span>
    </div>
    <div class="info-box common-flex-box">
      <img :src="artworkInfo.picPath" alt class="head" />
      <div class="author ellipsis">{{ artworkInfo.chArtistName }}</div>
      <strong class="price">{{ $t("PriceUnit") }}{{ artworkInfo.price | fnKeep }}</strong>
    </div>
    <div class="values-box pad-box text-center">
      <div class="common-detail-title">{{ $t("LastTranslate.Attribute") }}</div>
      <div class="text">
        {{ $t("LastTranslate.AttributeName") }}：{{ artworkInfo.chArtworkName }}
      </div>
      <div class="text">
        {{ $t("LastTranslate.AttributeAtr") }}：{{ artworkInfo.chArtistName }}
      </div>
      <div class="text">
        {{ $t("LastTranslate.AttributeDate") }}：{{ artworkInfo.finishTime }}
      </div>
      <div class="text">
        {{ $t("ArtworkDetail.ArtworkType") }}：{{ artworkInfo.chKindName }}
      </div>
      <div class="text">
        {{ $t("ArtworkDetail.Material") }}：{{ artworkInfo.chTexture }}
      </div>
      <div class="text">
        {{ $t("ArtworkDetail.Size") }}：{{
          artworkInfo.width ? artworkInfo.width + "cm" : ""
        }}
        {{ artworkInfo.width && artworkInfo.height ? "X" : "" }}
        {{ artworkInfo.height ? artworkInfo.height + "cm" : "" }}
      </div>
      <div class="text" v-for="(item, i) in artworkInfo.arrList" :key="i">
        {{ item.key }}：{{ item.value }}
      </div>
    </div>
    <div
      class="evaluation-box values-box pad-box"
      v-if="worksDetailsInfo.comment !== null"
    >
      <div class="common-detail-title text-center">
        {{ $t("ArtworkDetail.ArtCritics") }}
      </div>
      <div class="text">{{ worksDetailsInfo.comment }}</div>
    </div>
    <div class="evaluation-box values-box pad-box">
      <div class="common-detail-title text-center">
        {{ $t("ArtworkDetail.ArtworkDetails") }}
      </div>
      <img :src="worksDetailsInfo.logoPath" alt class="img" />
      <div class="text" v-html="worksDetailsInfo.chDescribe"></div>
    </div>
    <div class="artworklist-box">
      <div class="common-detail-title text-center">
        {{ $t("ArtworkDetail.Recommendations") }}
      </div>
      <div class="common-mobile-artwork-list" ref="artworkList">
        <van-row gutter="6" :style="`height: ${listHeight}PX;`">
          <van-col
            span="12"
            v-for="(item, i) in artworkList"
            :key="i"
            class="artwork-card"
            :style="`height: ${item.height}PX;top: ${item.top}PX;left: ${item.left}PX;`"
          >
            <router-link :to="`/artwork-detail?artworkId=${item.artworkId}`">
              <div class="artwork-item" :ref="`refs${i}`">
                <div class="img-box relative">
                  <h5 v-if="item.status != 5">
                    {{
                      item.status === 6
                        ? $t("ArtworkDetail.sold")
                        : item.status === 7
                        ? $t("ArtworkDetail.withdrawn")
                        : ""
                    }}
                  </h5>
                  <img :src="item.artworkPath" alt class="art-img" />
                  <div class="tips" v-if="item.excellent">
                    {{ $t("ArtworkDetail.Excellent") }}
                  </div>
                </div>
                <div class="text-box">
                  <div class="text ellipsis" v-html="item.chArtworkName"></div>
                  <div class="text ellipsis">{{ item.chArtistName }}</div>
                  <div class="text">{{ $t("PriceUnit") }} {{ item.price | fnKeep }}</div>
                </div>
              </div>
            </router-link>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 固定底部的下载按钮 -->
    <div class="download-btn-box" @click="toDown">
      <button class="app-btn">{{ $t("ArtworkDetail.download") }}</button>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
import mixinDown from "@/pages/mobile/views/mixin/mixinDown";
export default {
  mixins: [mixinDown],
  data() {
    return {
      artworkInfo: [],
      worksDetailsInfo: [],
      artworkList: [],
      colsHeight: [0, 0], //记录下来两列的当前高度，用来判断下一个放置在哪一列的下面
      listHeight: 0,
      query: {
        artworkId: this.$route.query.artworkId,
      },
    };
  },
  watch: {
    $route(to, form) {
      this.query.artworkId = to.query.artworkId;
      this.artwork();
      this.worksDetails();
    },
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  methods: {
    // 艺术品信息
    artwork() {
      this.$commonPromise("get", this.$Api.artwork, this.query).then((res) => {
        if (res.code === 200) {
          let arrList = [];
          res.data.artworkPropertyDTOList.forEach((item) => {
            let arr = [];
            if (item.artworkPropertyValueDTOList) {
              item.artworkPropertyValueDTOList.forEach((val) => {
                arr.push(val.chName);
              });
            } else if (item.type == 3 && item.chPropertyName) {
              arr.push(item.chPropertyName);
            }
            arrList.push({
              key: item.chName,
              value: arr.join(","),
            });
          });
          res.data.arrList = arrList;
          this.artworkInfo = res.data;
        }
      });
    },
    // 艺术品图文详情、评价
    worksDetails() {
      this.$commonPromise("get", this.$Api.worksDetails, this.query).then(
        (res) => {
          if (res.code === 200) {
            this.worksDetailsInfo = res.data;
            let arr = res.data.artworkList;
            //需要在渲染前动态添加style字段，检测变化时才会重新渲染
            arr.forEach((item, i) => {
              item.height = 0;
              item.left = 0;
              item.top = 0;
            });
            //必须添加style字段后才能渲染数组，才能检测添加的style变化
            this.artworkList = arr;
          }
        }
      );
    },
  },
  mounted() {
    this.artwork();
    this.worksDetails();
  },
  beforeUpdate() {
    this.$nextTick(() => {
      let listHeight = 0;
      const itemWith = this.$refs.artworkList.clientWidth / 2; //计算每列的宽度
      this.artworkList.forEach((item, i) => {
        setTimeout(() => {
          let k = i;
          const itemH = this.$refs[`refs${k}`][0].clientHeight + 24;
          this.artworkList[k].height = itemH;
          if (k < 2) {
            this.artworkList[k].top = 0;
            this.artworkList[k].left = k * itemWith + (2 * k - 1) * 3;
            this.colsHeight[k] = itemH;
          } else {
            let min = this.colsHeight[0];
            let minIndex = 0;
            this.colsHeight.forEach((col, index) => {
              if (col < min) {
                minIndex = index;
              }
            });

            this.artworkList[k].top = this.colsHeight[minIndex];
            this.artworkList[k].left =
              minIndex * itemWith + (2 * minIndex - 1) * 3;
            this.colsHeight[minIndex] += itemH;
          }

          //最后一个的时候根据哪一列高度最大来计算盒子高度
          if (k == this.artworkList.length - 1) {
            let max = this.colsHeight[0];
            let maxIndex = 0;
            this.colsHeight.forEach((col, index) => {
              if (col > max) {
                maxIndex = index;
              }
            });
            this.listHeight = this.colsHeight[maxIndex];
          }
        }, 500);
      });
    });
  },
};
</script>
<style lang="scss" scoped>
.mobile-artwork-detail-box {
  .top-img-box {
    height: 0;
    padding-bottom: 100%;
    background-color: #f5f5f5;
    .art-img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 90%;
      max-height: 90%;
    }
  }
  .name-box {
    padding: 29px 32px;
    font-size: 32px;
    line-height: 38px;
    .name {
      flex: 1;
    }
  }
  .info-box {
    padding: 24px 32px;
    background-color: #f5f5f5;
    .head {
      margin-right: 16px;
      height: 64px;
      width: 64px;
      border-radius: 100%;
    }
    .author {
      flex: 1;
      min-width: 200px;
      font-size: 28px;
      line-height: 64px;
    }
    .price {
      font-size: 36px;
      line-height: 64px;
    }
  }
  .common-detail-title {
    margin-top: 0;
  }
  .pad-box {
    padding: 32px 32px 40px;
  }
  .values-box {
    border-bottom: 1px solid #eee;
    .text {
      margin-bottom: 23px;
    }
  }
  .evaluation-box {
    line-height: 48px;
    .img {
      width: 100%;
      margin-bottom: 40px;
    }
  }
  .download-btn-box {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 32px;
    border-top: 1px solid #eee;
    background-color: #fff;
    .app-btn {
      width: 100%;
      height: 88px;
      line-height: 88px;
      text-align: center;
      font-size: 28px;
      border: 0;
      outline: none;
      background-color: $main-color;
    }
  }
}
.img-box {
  position: relative;
  h5 {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    text-align: center;
    line-height: 150px;
    color: #fff;
    font-size: 14px;
    transform: rotate(45deg);
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>